import React from 'react';

import * as styles from '../icons.css';

export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={60}
    viewBox="0 0 63 73"
    xmlSpace="preserve"
    focusable="false"
    fill="currentColor"
    className={styles.root}
  >
    <g transform="translate(1 1)" fill="none" fillRule="evenodd">
      <path
        d="m44.788 38 14.21 14.293c1.84 1.848 1.858 4.867.042 6.74a4.622 4.622 0 0 1-6.618.043L38 44.57s4.297-2.608 6.788-6.57z"
        className={[styles.stroke, styles.fill].join(' ')}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.353.022C11.927-.54.588 9.808.022 23.127c-.566 13.326 9.857 24.584 23.282 25.144 13.418.562 24.758-9.784 25.324-23.11C49.194 11.84 38.77.582 25.353.02z"
        className={styles.stroke}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <ellipse
        className={styles.fill}
        cx={24.325}
        cy={24.345}
        rx={19.902}
        ry={19.955}
      />
      <path
        d="M26.917 16.754a8.011 8.011 0 0 0-1.85 1.561 8.502 8.502 0 0 0-1.36 2.124 9.4 9.4 0 0 0-1.373-2.124 8.099 8.099 0 0 0-1.807-1.56 7.405 7.405 0 0 0-1.635-.707 6.171 6.171 0 0 0-2.509-.19 6.605 6.605 0 0 0-2.004.576 5.64 5.64 0 0 0-1.1.677 6.355 6.355 0 0 0-.944.92 6.36 6.36 0 0 0-.756 1.128c-.051.069-.053.084-.053.102-.022.017-.038.034-.057.053a8.207 8.207 0 0 0-.701 1.89 9.402 9.402 0 0 0-.231 2.126c0 .427.056.821.166 1.23.104.407.28.84.52 1.304.219.462.485.92.796 1.38a11.6 11.6 0 0 0 1.07 1.36 32.164 32.164 0 0 0 2.48 2.557c.888.82 1.826 1.522 2.816 2.273.893.698 1.718 1.253 2.47 1.772.747.523 1.425.854 2.029 1.21.255.155.453.269.59.347.138.075.214.115.233.115.017 0 .096-.04.234-.115.137-.078.334-.186.589-.32.603-.373 1.28-.69 2.033-1.219.748-.53 1.57-1.046 2.469-1.71a44.595 44.595 0 0 0 2.839-2.38 30.438 30.438 0 0 0 2.456-2.53c.402-.446.757-.893 1.071-1.344.31-.453.577-.909.795-1.37.236-.46.41-.9.523-1.318a4.78 4.78 0 0 0 .162-1.19c-.017-.803-.1-1.51-.245-2.178a7.474 7.474 0 0 0-.658-1.84l-.112-.205a8 8 0 0 0-.781-1.114 6.638 6.638 0 0 0-2.032-1.6 5.8 5.8 0 0 0-1.194-.435 6.907 6.907 0 0 0-1.617-.205c-.587 0-1.153.083-1.7.243a7.45 7.45 0 0 0-1.622.706z"
        className={[styles.stroke, styles.highlightFill].join(' ')}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <ellipse className={styles.shadow} cx={25} cy={65} rx={17} ry={3} />
    </g>
  </svg>
);
